import useNetwork from '@/hooks/useNetwork';
import queryString from 'query-string';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 0 } = props;

  const network = useNetwork();

  return useConnect('offer.find', {
    where: {
      filter: { active: true, nearby: 50, siteNetwork: network?.id },
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function(model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}
